import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Info, ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { parseLocaleFromPath, localePath } from "@/lib/locale";

const L = {
  hr: { title: "Plaćanje otkazano", body: "Niste izvršili plaćanje. Vaša košarica je sačuvana.", back_cart: "Natrag na košaricu", back_models: "Pregledaj modele" },
  en: { title: "Payment cancelled", body: "You did not complete the payment. Your cart is saved.", back_cart: "Back to cart", back_models: "Browse models" },
  de: { title: "Zahlung abgebrochen", body: "Sie haben die Zahlung nicht abgeschlossen. Ihr Warenkorb ist gespeichert.", back_cart: "Zurück zum Warenkorb", back_models: "Modelle ansehen" },
  fr: { title: "Paiement annulé", body: "Vous n'avez pas terminé le paiement. Votre panier est sauvegardé.", back_cart: "Retour au panier", back_models: "Voir les modèles" },
};

export default function CheckoutCancel() {
  const { locale } = parseLocaleFromPath(useLocation().pathname);
  const t = L[locale] || L.hr;
  return (
    <>
      <SEO title={`${t.title} — Tambure Žmegač`} description={t.body} />
      <section className="bg-background grain-bg min-h-[55vh] flex items-center">
        <div className="max-w-xl mx-auto px-5 py-16 text-center" data-testid="checkout-cancel-page">
          <Info className="h-12 w-12 text-muted-foreground mx-auto mb-5" strokeWidth={1.2} />
          <h1 className="font-serif text-3xl text-foreground">{t.title}</h1>
          <p className="mt-2 text-sm text-foreground/70 max-w-md mx-auto">{t.body}</p>
          <div className="mt-8 flex gap-2 justify-center">
            <Link to={localePath(locale, "/cart")}>
              <Button variant="outline" data-testid="cancel-back-cart"><ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.5} /> {t.back_cart}</Button>
            </Link>
            <Link to={localePath(locale, "/models")}>
              <Button data-testid="cancel-back-models" className="shadow-interactive">{t.back_models}</Button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
